import React from "react";
import cupImage1 from "../../../../assets/images/others/host-side-images/cupImage1.png";
import cupImage2 from "../../../../assets/images/others/host-side-images/cupImage2.png";
import cupImage3 from "../../../../assets/images/others/host-side-images/cupImage3.png";
import cupImage4 from "../../../../assets/images/others/host-side-images/cupImage4.png";
import cupImage5 from "../../../../assets/images/others/host-side-images/cupImage5.png";
import cupImage6 from "../../../../assets/images/others/host-side-images/cupImage6.png";

interface Cups {
  id: number;
  cupImage: string;
  price: string;
  title: string;
  times: string;
}
const cupsData: Cups[] = [
  {
    id: 1,
    cupImage: cupImage1,
    price: "1$",
    title: "Community Roast",
    times: "2 times",
  },
  {
    id: 2,
    cupImage: cupImage2,
    price: "2$",
    title: "Thanks Latte",
    times: "4 times",
  },
  {
    id: 3,
    cupImage: cupImage3,
    price: "3$",
    title: "Curious Cappucccino",
    times: "4 times",
  },
  {
    id: 4,
    cupImage: cupImage4,
    price: "4$",
    title: "Mentors Mocha",
    times: "2 times",
  },
  {
    id: 5,
    cupImage: cupImage5,
    price: "5$",
    title: "Thank you very Matcha",
    times: "4 times",
  },

  {
    id: 6,
    cupImage: cupImage6,
    price: "6$",
    title: "Grateful Grounds",
    times: "5 times",
  },
];
const CupOfGratitude = () => {
  return (
    <div className="">
      <h1 className="text-3xl font-medium text-blackie my-10">All (21 Cups)</h1>
      <div className="flex flex-wrap gap-4">
        {cupsData.map((cup) => (
          <div key={cup.id} className="relative text-center w-[185px]">
            <img src={cup.cupImage} alt={cup.title} className="" />
            <span className="absolute top-12 right-[-3px] -translate-x-1/2 -translate-y-1/2 bg-brown text-[#FFF0D8] text-[44px] font-bold">
              {cup.price}
            </span>
            <h3 className="text-blackie text-4xl font-bold my-2">
              {cup.title}
            </h3>
            <div className="mx-auto w-fit mt-2">
              <p className="text-xs bg-yellowBg text-yellowText px-3 py-1 rounded-full">
                {cup.times}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CupOfGratitude;
